export const selectors = {
  pagination: {
    button: {
      left: "pagination-button-left",
      right: "pagination-button-right",
    },
  },
};
